export default {
    state: {
        gestiones: [],
        archivos: [],
        loading: false,
    },
    getters: {
        gestiones: (state) => state.gestiones,
        archivos: (state) => state.archivos,
        loading: state => state.loading,
    },
    mutations: {
        SET_GESTIONES: (state, payload) => state.gestiones = payload,
        SET_ARCHIVOS: (state, payload) => state.archivos = payload,
        setLoading: (state, payload) => state.loading = payload,
    },
    actions: {
        listarArchivos({
            commit
        }) {
            return new Promise((res, rej) => {
                this.getters.api.get('/utilidades/cargue-masivo-gestion')
                    .then(response => {
                        commit('SET_ARCHIVOS', response.data)
                        res(response)
                    }).catch(error =>
                        rej(error)
                    )
            })
        },
        fetch({
            commit
        }, payload) {
            this.dispatch('index', payload)
                .then((response) => {
                    commit('SET_GESTIONES', response.datos)
                })
        },
        cargarGestion({
            commit,
            dispatch
        }, payload) {
            return new Promise((res, rej) => {
                this.getters.api.post('/utilidades/cargue-masivo-gestion', payload)
                    .then(response => {
                        res(response)
                    }).catch(error =>
                        rej(error)
                    )
            })
        },
        descargarArchivo({
            commit
        }, payload) {
            return this.getters.api.get('/utilidades/cargue-masivo-gestion/descargar-archivo', {
                params: payload,
                responseType: 'blob'
            })
        },
        descargarLog({
            commit
        }, payload) {
            return this.getters.api.get('/utilidades/cargue-masivo-gestion/descargar-log', {
                params: payload,
                responseType: 'blob'
            })
        }
    }
}